const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedOriginalGame: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const originalgame = (state = initialState, action) => {
	switch (action.type) {
		case 'ORIGINALGAME_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'ORIGINALGAME_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'ORIGINALGAME_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'ORIGINALGAME_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'ORIGINALGAME_GET_CURRENT':
			return {
				...state,
				selectedOriginalGame: action.selectedOriginalGame,
			}
		case 'ORIGINALGAME_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default originalgame
